<template>
  <div class="page">
    <button class="btn secondary" @click="$router.back()">← Back</button>
    <h2 style="margin-top:12px;">Edit Sale</h2>

    <div v-if="!form" class="helper" style="margin-top:12px;">Loading…</div>

    <div v-else class="card" style="padding:16px;margin-top:12px;max-width:720px;">
      <div class="grid" style="grid-template-columns: 1fr 1fr; gap:12px;">
        <div>
          <label class="helper">Date</label>
          <input class="input" type="date" v-model="form.dateISO">
        </div>
        <div>
          <label class="helper">Category</label>
          <input class="input" v-model="form.category">
        </div>
        <div>
          <label class="helper">List Price (₹)</label>
          <input class="input" type="number" v-model.number="form.listPrice" min="0">
        </div>
        <div>
          <label class="helper">Sale Value (₹)</label>
          <input class="input" type="number" v-model.number="form.saleValue" min="0">
        </div>
        <div>
          <label class="helper">User ID</label>
          <input class="input" v-model="form.userId">
        </div>
        <div>
          <label class="helper">Branch ID</label>
          <input class="input" v-model="form.branchId">
        </div>
      </div>

      <div class="row" style="margin-top:16px;">
        <button class="btn primary" :disabled="busy" @click="save">{{ busy ? 'Saving…' : 'Save' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'AdminSaleEdit',
  data(){ return { form: null, busy:false } },
  computed:{
    rec(){ return this.$store.getters['sales/byId'](this.$route.params.id) },
  },
  async created(){
    if (this.rec) this.form = { ...this.rec }
    else {
      // fallback: pull current month to try to locate the record
      const mk = new Date().toISOString().slice(0,7)
      await this.$store.dispatch('sales/fetchMonth', mk)
      const again = this.$store.getters['sales/byId'](this.$route.params.id)
      if (again) this.form = { ...again }
    }
  },
  methods:{
    async save(){
      this.busy = true
      try{
        await this.$store.dispatch('sales/adminUpdateSale', this.form)
        this.$router.push({ name:'admin' })
      }finally{
        this.busy = false
      }
    }
  }
}
</script>
